import React from 'react';
import { Box } from '@chakra-ui/react';
import TextTruncate from 'react-text-truncate';
export interface ApartmentTitleProps {
  title: string;
  hashRoute: string;
}
export const ApartmentTitle = (props: ApartmentTitleProps): JSX.Element => {
  const { title } = props;
  return (
    <Box
      _hover={{
        textDecoration: 'underline',
      }}
      cursor="pointer"
      color="blue.500"
      fontSize="xl"
      fontWeight={'semibold'}
      flex={1}>
      <TextTruncate line={1} text={title} truncateText={'...'} />
    </Box>
  );
};
